import { CaseRelationInput } from './CaseService'
import type { StatusCategory } from '~/entities/work-unit'

type ContentType =
  | 'chatmessagev2'
  | 'phonecall'
  | 'careplan'
  | 'priorauthorization'
  | 'steerage'
  | 'waiver'
  | 'worklistitem'
  | 'measurereport'
  | 'email'

export interface MessageIdentifier {
  type: ContentType
  id: number
}

/**
 * getMessageCaseRelation
 * @returns case relation input for the add-relation mutation
 */
export const getMessageCaseRelation = (messageIdentifier: MessageIdentifier): CaseRelationInput => {
  return {
    content_type: messageIdentifier.type,
    object_id: messageIdentifier.id,
  }
}

export const workunitCompleteStates: Array<StatusCategory | undefined | null> = [
  'complete',
  'deferred',
]

// Open-check keyed off the case `status_category` field.
type StatusCarrier = { status_category?: StatusCategory | null }
const caseIsClosed = (c: StatusCarrier) => workunitCompleteStates.includes(c.status_category)
export const caseIsOpen = (c: StatusCarrier) => !caseIsClosed(c)
